<template>
    <div>
        <div v-if="type == 'icon'">
            <a
                :href="metadataUrl"
                target="metadata"
                onclick="event.stopPropagation()"
            >
                <img
                    class="theme-eye px-1"
                    src="~@/assets/imported-icons/ic_fluent_info_20_regular.svg"
                    :title="$t('searchMetadata.show')"
                    :alt="$t('searchMetadata.show')"
                />
            </a>
        </div>
        <div v-else-if="type == 'button'">
            <b-button :href="metadataUrl" target="metadata">
                {{ $t('searchMetadata.showButton') }}</b-button
            >
        </div>
    </div>
</template>

<script>
    import { getNedglobeApi } from '../../../../services/api/nedglobe';

    export default {
        props: {
            layer: { type: Object, required: true },
            type: { type: String, required: false, default: 'icon' }
        },
        data() {
            return { metadataUrl: null };
        },
        created() {
            this.$_getMetadataUrl();
        },
        methods: {
            async $_getMetadataUrl() {
                const service = await getNedglobeApi(this.$store);
                service.withServer({
                    url: window.location.origin,
                    description: 'origin'
                });
                this.metadataUrl = service.getRequestConfigForOperation(
                    'GetLayerMetadataHtml',
                    [this.layer.id]
                )?.url;
            }
        }
    };
</script>

<style scoped>
.theme-eye {
    cursor: pointer;
}
</style>
